// API responses sometimes return numeric IDs as strings. Components expect
// numbers (PropTypes, === comparisons against variantId/variationId, etc.),
// so normalize at the data-shaping boundary rather than loosening every
// consumer's PropTypes.
export function toNumericId(value) {
  if (value === null || value === undefined || value === "") return null;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
}
